// import { useTheme } from "next-themes"
// import { Toaster as Sonner, toast } from "sonner"

// const Toaster = ({
//   ...props
// }) => {
//   const { theme = "system" } = useTheme()

//   return (
//     <Sonner
//       theme={theme}
//       className="toaster group"
//       toastOptions={{
//         classNames: {
//           toast:
//             "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
//           description: "group-[.toast]:text-muted-foreground",
//           actionButton:
//             "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
//           cancelButton:
//             "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
//         },
//       }}
//       {...props} />
//   );
// }

// export { Toaster, toast }


"use client"

import { Toaster as Sonner, toast, ToasterProps } from "sonner"
import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react"

interface ShadToasterProps extends ToasterProps { }

const Toaster = ({ ...props }: ShadToasterProps) => {
  return (
    <Sonner
      position="top-right"
      expand={false}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "flex items-center gap-3 w-full p-4 rounded-lg shadow-lg border",
          title: "font-medium text-sm",
          description: "text-sm opacity-80",
          actionButton: "px-3 py-1.5 rounded text-sm font-medium",
          cancelButton: "px-3 py-1.5 rounded text-sm",
          success: "bg-green-50 border-green-200 text-green-800",
          error: "bg-red-50 border-red-200 text-red-800",
          warning: "bg-amber-50 border-amber-200 text-amber-800",
          info: "bg-blue-50 border-blue-200 text-blue-800",
        },
      }}
      icons={{
        success: <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />,
        error: <XCircle className="w-5 h-5 text-red-600 flex-shrink-0" />,
        warning: <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />,
        info: <Info className="w-5 h-5 text-blue-600 flex-shrink-0" />,
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
